// extracted by mini-css-extract-plugin
export default {"addCategorySection":"style_addCategorySection__zgr9j","actionsSection":"style_actionsSection__M4oSw","formSection":"style_formSection__laHd5"};